import GSTReturns from "../taxes/GSTReturns";
export default function GSTSummary() { return <GSTReturns />; }
